import React from 'react';
import { Field } from 'react-final-form';
import type { FieldProps, FieldRenderProps } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import DatePickerInputAdapter from '../DatePickerInputAdapter/DatePickerInputAdapter';
import type { DatePickerInputProps } from '../DatePickerInput/DatePickerInput';
import transformValidateProp from '../../util/transformValidateProp';

export interface FormDatePickerProps<
  RP extends FieldRenderProps<string, T>,
  T extends HTMLElement = HTMLElement
> extends Omit<FieldProps<string, RP, T>, 'validate'>,
    DatePickerInputProps {
  name: string;
  validate?: FieldValidator<string>[] | FieldValidator<string> | null;
  /** *deprecated* can just pass validator function to `validate` */
  customValidator?: FieldValidator<string> | null;
}

/**
 * ```import FormDatePicker from '@zola/zola-ui/src/components/Form/DatePickerInput/FormDatePicker';```
 *
 * Use with react-final-form
 * */
const FormDatePicker = <
  RP extends FieldRenderProps<string, T>,
  T extends HTMLElement = HTMLElement
>({
  name,
  validate,
  customValidator,
  ...rest
}: FormDatePickerProps<RP, T>): React.ReactElement => {
  const composedValidators = transformValidateProp(validate || customValidator);

  return (
    <Field name={name} validate={composedValidators} {...rest}>
      {(props) => <DatePickerInputAdapter {...props} />}
    </Field>
  );
};

export default FormDatePicker;
